// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PendingNiche {
  justify-content: center;
  align-items: center;
  display: grid;
  grid-template-columns: 296px 270px;
  grid-gap: 30px;
  gap: 30px;
  margin: 96px 0 0;
  color: var(--color_neutral_800);
}
.PendingNiche .Text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.PendingNiche .Text-wrapper p {
  font-size: 24px;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/pending-niche/pending-niche.styles.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;EACA,cAAA;EAAA,SAAA;EACA,gBAAA;EACA,+BAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EACE,eAAA;AACN","sourcesContent":[".PendingNiche {\n  justify-content: center;\n  align-items: center;\n  display: grid;\n  grid-template-columns: 296px 270px;\n  gap: 30px;\n  margin: 96px 0 0;\n  color: var(--color_neutral_800);\n\n  .Text-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n\n    p {\n      font-size: 24px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
